import React, { useState, useEffect, useRef } from "react";
import { ProgressBar, Spinner, Card, Modal, Button, Form, Image, Container, Row, Col, Offcanvas, Alert, ListGroup } from 'react-bootstrap';
import { FaMicrophone, FaPaperPlane, FaArrowLeft, FaDollarSign, FaFeatherAlt, FaClock, FaEllipsisH, FaQuestion, FaShare, FaRing, FaBell, FaFlag, FaLifeRing, FaExclamationTriangle, FaTimes, FaFlagCheckered, FaRegFlag, FaRegEyeSlash, FaRegEye,} from "react-icons/fa";
import { signInWithGoogle, auth, provider, signInWithPopup, onAuthStateChanged } from "./firebase";
import 'bootstrap/dist/css/bootstrap.min.css';
import emailjs from "emailjs-com";
import axios from 'axios';

import { useNavigate, useLocation } from "react-router-dom";
import { getFirestore, deleteField, doc, setDoc, getDoc, collection,query, where, getDocs, addDoc, serverTimestamp, onSnapshot, orderBy, updateDoc, arrayUnion, increment, writeBatch } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { FaFlagUsa, FaSchoolFlag, FaStar } from "react-icons/fa6";
import mixpanel from 'mixpanel-browser';


const db = getFirestore();

const ActiveUserChat = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const storage = getStorage();
    const messagesEndRef = useRef(null); // Ref for auto-scrolling


    // const [user, setUser] = useState(null);
    const user = location.state?.user;
    // console.log('auth: ', auth.currentUser)
    // console.log('user: ', user)

    // const [selectedConsultant, setSelectedConsultant] = useState(null);
    var selectedConsultant = location.state?.selectedConsultant;
    // console.log("selectedConsultant:", selectedConsultant)
    // console.log("selectedConsultant: ", selectedConsultant)

    // activechat
    // const [activeChat, setActiveChat] = useState(null);
    var activeChat = location.state?.activeChat;
    // console.log("activeChat:", activeChat)

    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [recording, setRecording] = useState(false);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    // credits
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [credits, setCredits] = useState(null); // Default 0 credits
    const [timeRemaining, setTimeRemaining] = useState(0);
    const [showRechargeModal, setShowRechargeModal] = useState(false);
    const countdownRef = useRef(null);
    const [rechargeNotificationModal, setRechargeNotificationModal] = useState(false);
    const [customAmount, setCustomAmount] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("stripe");

    const MINIMUM_AMOUNT = 5; // Set your threshold
    const [canReview, setCanReview] = useState(false);

    // pay sacrifice invoice
    const [sacrificeAmount, setSacrificeAmount] = useState('');
    const [sacrificePaymentMethod, setSacrificePaymentMethod] = useState('credits');
    const [showSacrificeModal, setShowSacrificeModal] = useState(false);
    const [insufficient, setInsufficient] = useState(false);

    // list of invoices
    const [consultantInvoices, setConsultantInvoices] = useState([]);
    const [showInvoicesModal, setShowInvoicesModal] = useState(false);
    const [invoiceId, setInvoiceId] = useState(false)
    // add review
    const [reviewText, setReviewText] = useState("");
    const [selectedRating, setSelectedRating] = useState(5);
    const [reviewSubmitted, setReviewSubmitted] = useState(false);

    const [reportSent, setReportSent] = useState(false);

    // end chat
    const [showEndChatModal, setShowEndChatModal] = useState(false);
    const [showChatEndedModal, setShowChatEndedModal] = useState(false);

    {/* End Chat Confirmation Modal */}
    const [isChecked, setIsChecked] = useState(false);

    // canvas
    const [showMoreOptions, setShowMoreOptions] = useState(false);

    // SOS modal
    const [showReportModal, setShowReportModal] = useState(false);
    const [loading, setLoading] = useState(false); 
    
    // scanner modal
    const [showScannerModal, setShowScannerModal] = useState(false);
    const [scanResult, setScanResult] = useState(null);
    // const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

     // decrypting
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [decryptedText, setDecryptedText] = useState('');
    const [showDecryptModal, setShowDecryptModal] = useState(false);
    const [passphrase, setPassphrase] = useState('');
    const [globalDecryptionKey, setGlobalDecryptionKey] = useState(null);
    const [decryptedMessages, setDecryptedMessages] = useState({});

    const welcomeMessageTriggered = useRef(false); 
    const [showConfirmConsultantInvoiceModal, setShowConfirmConsultantInvoiceModal] = useState(false);
    
    const [audioErrors, setAudioErrors] = useState({});

    const [consultantMode, setConsultantMode] = useState('offline');

    const [isGift, setIsGift] = useState(false);
    const [recipientEmail, setRecipientEmail] = useState("");
    const [recipientName, setRecipientName] = useState("");
    const [showClaimModal, setShowClaimModal] = useState(false);
    const [claimMessage, setClaimMessage] = useState(""); // For feedback


    // When user clicks "View message" or triggers decryption
      const handleRequestDecrypt = (msg) => {
        
        if (globalDecryptionKey !== null) {
          // console.log('globalDecryptionKey:', globalDecryptionKey)
          // console.log('passphrase:', passphrase)
          // // If key exists, decrypt immediately without showing modal
          decryptAllMessages();
              // decryptSingleMessage(msg, globalDecryptionKey);
          // setShowDecryptModal(true);
        } else {
          setShowDecryptModal(true);
        }
      };


    // fill questionaires
    const [formData, setFormData] = useState({
        name: "",
        dob: "",
        motherName: "",
        fatherName: "",
        birthPlace: "",
        origin: "",
        dieties: "",
        rivers: "",
        facePhoto: null,
        rightPalmPhoto: null,
        leftPalmPhoto: null,
      });


  const handleSubmitReview = async () => {
      mixpanel.track('submit review', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              rating: selectedRating,
              review: reviewText
            })
    // console.log("Rating:", selectedRating);
    // console.log("Review:", reviewText);
    // console.log("Consultant_id:", selectedConsultant.id);
    setReviewSubmitted(false);

    if (!selectedConsultant?.id) return;

      try {
        const priestRef = doc(db, "priest_users", selectedConsultant.id);
        const docSnap = await getDoc(priestRef);

        // await updateDoc(priestRef, {
        //   rating: arrayUnion(selectedRating),
        //   review: arrayUnion(reviewText),
        //   reviewCount: increment(1)
        // });

        if (docSnap.exists()) {
          const currentRatings = docSnap.data().rating || [];
          const currentReviews = docSnap.data().review || [];
        
          await updateDoc(priestRef, {
            rating: [...currentRatings, selectedRating],
            review: [...currentReviews, reviewText],
            reviewCount: increment(1)
          });

        // If good review, update publicReview/priests
        if (selectedRating > 3.9 && reviewText.trim() !== "") {
          const publicRef = doc(db, "publicReview", "priests");
          const publicSnap = await getDoc(publicRef);

          const publicRatings = publicSnap.exists() ? publicSnap.data().rating || [] : [];
          const publicReviews = publicSnap.exists() ? publicSnap.data().review || [] : [];

          await setDoc(
            publicRef,
            {
              rating: [...publicRatings, selectedRating],
              review: [...publicReviews, reviewText],
              reviewCount: increment(1),
            },
            { merge: true }
          );
        }
  
        // console.log("Review submitted successfully.");
        // Optionally clear state
        setSelectedRating(5);
        setReviewText("");

        // Show success message
        setReviewSubmitted(true);

        // Hide it after 3 seconds
        setTimeout(() => setReviewSubmitted(false), 3000);
      }
      } catch (error) {
        console.error("Error submitting review:", error);
        mixpanel.track('submitReviewError', {
          error: error,
          user: user.uid
        })
      }

  };


  // --- Encryption/Decryption Utilities ---

// --- Constants & Utilities ---
// const userPassphrase = "testKeyPhrase"; // From user session or input
// const consultantPassphrase = "consultantKey"; // Assume stored securely per consultant
const fixedSalt = new TextEncoder().encode("fixedSalt");

const GLOBAL_KEYPHRASE = "globallyPhrased";

async function getKeyFromPassphrase(passphrase) {
    const encoder = new TextEncoder();
    const salt = encoder.encode("fixedSalt");
    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(passphrase),
      "PBKDF2",
      false,
      ["deriveKey"]
    );
    return crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt,
        iterations: 100000,
        hash: "SHA-256"
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      true,
      ["encrypt", "decrypt"]
    );
  }

  async function decryptText(cipherText, ivArray, key) {
    const binary = Uint8Array.from(atob(cipherText), c => c.charCodeAt(0));
    const iv = new Uint8Array(ivArray);
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      binary
    );
    return new TextDecoder().decode(decrypted);
  }


  async function encryptText(plainText, key) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encoded = new TextEncoder().encode(plainText);
    const cipherBuffer = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      encoded
    );
    return {
      cipherText: btoa(String.fromCharCode(...new Uint8Array(cipherBuffer))),
      iv: Array.from(iv)
    };
  }


  // Auto-scroll to the latest message
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  // checking online status
    useEffect(() => {
      if (!user?.id) return;
      const userRef = doc(db, "priest_users", user.id);
      // Set mode to "online"
      updateDoc(userRef, { mode: "online" });

      // Set mode to "offline" on unload
      const handleBeforeUnload = () => {
        updateDoc(userRef, { mode: "offline" });
      };
      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        updateDoc(userRef, { mode: "offline" });
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, [user?.id]);

    
    useEffect(() => {
      if (!selectedConsultant?.id) return;

      const ref = doc(db, "priest_users", selectedConsultant.id);
      const unsub = onSnapshot(ref, (docSnap) => {
        if (docSnap.exists()) {
          setConsultantMode(docSnap.data().mode || 'offline');
        } else {
          setConsultantMode('offline');
        }
      });

      return () => unsub();
    }, [selectedConsultant?.id]);

  

  // console.log('rateMultiplier: ', activeChat.consultantPrice * 2)
  // console.log('credits: ', credits)
  useEffect(() => {
    if (credits !== null && selectedConsultant && credits < activeChat.consultantPrice * 3) {
      // console.log('rateMultiplier: ', activeChat.consultantPrice * 2)
      // console.log('credits: ', credits)
      // setTimeRemaining(credits/activeChat.consultantPrice)
      setRechargeNotificationModal(true);
      // throw new Error("Insufficient credits");
    }
  }, [credits, selectedConsultant]);


  useEffect(() => {
    // console.log(user)
    if (!activeChat || !user?.id) return;
  
    const unsubscribe = onSnapshot(
      query(
        collection(db, "chatRooms", activeChat.chatRoomId, "messages"),
        orderBy("createdAt")
      ),
      async (snapshot) => {
        const rawMessages = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          ref: doc.ref
        }));

        // ✅ Update  lastSeen
          if (rawMessages.length > 0) {
            const chatRef = doc(db, "chatRooms", activeChat.chatRoomId);
            await updateDoc(chatRef, {
              [`lastSeen.${user.id}`]: serverTimestamp()
            });
          }

          // No global key, just display raw messages
          setMessages(rawMessages);
          // console.log('rawMessages delivered')

        // }
      }
    );
  
    return () => unsubscribe();
  }, [activeChat, user?.id, globalDecryptionKey]);
  
  
    useEffect(() => {
      if (!user?.id) return;

      const loadSavedKey = async () => {
        // if (!user.id) return;
  
        const savedBase64 = localStorage.getItem("decryptionKeyFor_" + user.id);
        if (savedBase64) {
          try {
            const rawKey = Uint8Array.from(atob(savedBase64), c => c.charCodeAt(0));
            const importedKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
            setGlobalDecryptionKey(importedKey);
            // console.log("importedKey: ", importedKey);
            // console.log("globalDecryptionKey: ", globalDecryptionKey);
            // console.log("Restored globalDecryptionKey from localStorage");
          } catch (err) {
            console.error("Failed to import saved key", err);
            localStorage.removeItem("decryptionKeyFor_" + user.id); // fallback
            mixpanel.track('importSavedKeyError', {
              error: err,
              user: user.uid
            })
          }
        }
      };
  
      loadSavedKey();
    }, [user?.id]);
    
  // na here o
    useEffect(() => {
    if (globalDecryptionKey && messages.length) {
      decryptAllMessages();
    }
  }, [messages, globalDecryptionKey]);
  
  
  // useEffect(() => {
  //   // console.log('userid:', user?.id)
  //   if (!user?.id) return;
  //   const base64Key = localStorage.getItem("decryptionKeyFor_" + user.id);
  //   if (base64Key) {
  //     const rawKey = Uint8Array.from(atob(base64Key), c => c.charCodeAt(0));
  //     crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]).then(key => {
  //       setGlobalDecryptionKey(key);
  //       decryptAllMessages(key);
  //     });
  //   }
  // }, [user?.id]);


    // Listen for "ended" Status
    useEffect(() => {
        if (activeChat && activeChat.chatRoomId) {
          const chatRequestRef = doc(db, "chatRooms", activeChat.chatRoomId);
          // console.log('consultant sending ending req')
          const unsubscribe = onSnapshot(chatRequestRef, (docSnapshot) => {
            if (docSnapshot.exists()) {
              const data = docSnapshot.data();
              // console.log('chat status1: ', data.status)
              // console.log('showChatEndedModal: ', showChatEndedModal)
              // console.log('showEndChatModal: ', showEndChatModal)
            // setShowChatEndedModal(false);
              if (data.status === "ended") {
                // console.log('chat status2: ', data.status)
                // consultant ended the chat, close users's chat UI
                // setActiveChat(null);
                // Show a modal to inform the consultant that the user ended the chat
                setShowChatEndedModal(true);
                // precaution: its causing errors when you end session 
                // from consultant and then request again so:
                setShowEndChatModal(false)
              }
            }
          });
      
          return () => unsubscribe();
        }
    }, [activeChat]);


  useEffect(() => {

    // console.log('selectedConsultant: ', selectedConsultant)
    // console.log('activeChat: ', activeChat)

    if (!activeChat?.chatRoomId || !selectedConsultant?.id) return;

    if(selectedConsultant.email === 'okojieose111@gmail.com') return;

    // console.log('selectedConsultant: ', selectedConsultant)
    // console.log('activeChat: ', activeChat)

    const chatRoomRef = doc(db, "chatRooms", activeChat.chatRoomId);

    const checkAndSendWelcome = async () => {
      
      // ⛔ prevent multiple triggers in same session
      if (welcomeMessageTriggered.current) return;
      welcomeMessageTriggered.current = true;

      try {
        const chatRoomSnap = await getDoc(chatRoomRef);
        const welcomeSent = chatRoomSnap.exists() ? chatRoomSnap.data().welcomeMessageSent : false;

        if (!welcomeSent) {
          await sendWelcomeMessage();
          await sendConsultationInvoice();

          // Mark welcome message as sent
          await updateDoc(chatRoomRef, { welcomeMessageSent: true });
        }
      } catch (err) {
        console.error("Error checking/sending welcome message:", err);
        mixpanel.track('SendWelcomeMessage&InvoiceError', {
          error: err,
          user: user.uid
        })
      }
    };

    checkAndSendWelcome();
  }, [activeChat?.chatRoomId, selectedConsultant?.id]);



// useEffect(() => {
//     if (activeChat?.chatRoomId) {
//       sendQuestionnaireInfo();
//     }
//   }, [activeChat]);


  // useEffect(() => {
  //     if (selectedConsultant && credits > 0) {
  //       startCreditTimer();
  //     } else if (credits <= 0) {
  //       clearInterval(countdownRef.current);
  //       setShowRechargeModal(true);
  //     }
  //     return () => clearInterval(countdownRef.current);
  //   }, [selectedConsultant, credits]);
  

    // Listen for authentication state changes
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
        // setUserName(currentUser.displayName)
        // setUserPhoto(currentUser.photoURL)
      //   setUser(currentUser); // Save user in state
      });
  
      return () => unsubscribe(); // Cleanup listener on unmount
    }, []);


    useEffect(() => {
      // console.log("user: ", user)
      if (user?.id ) {
          // console.log("activeChat: ", activeChat)
          const userRef = doc(db, "priest_users", user.id);
          const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
              if (docSnapshot.exists()) {
                // console.log("activeChat.consultationCharge: ", activeChat.consultationCharge)
                // console.log("activeChat.consultantPrice: ", activeChat.consultantPrice)
                // setTimeRemaining(docSnapshot.data().credits/activeChat.consultantPrice)
                if(activeChat.consultantPrice == 0){
                  setTimeRemaining("Invalid")
                }else{
                  setTimeRemaining(`${Math.floor(docSnapshot.data().credits / activeChat.consultantPrice)}m ${Math.round(((docSnapshot.data().credits / activeChat.consultantPrice) % 1) * 60)}s`);  
                  // const remainingMinutes = docSnapshot.data().credits / activeChat.consultantPrice;
                  // const totalSeconds = Math.floor(remainingMinutes * 60);
                  // setTimeRemaining(totalSeconds);
                }
                // console.log(Number(`${Math.floor(docSnapshot.data().credits / activeChat.consultantPrice)}m ${Math.round(((docSnapshot.data().credits / activeChat.consultantPrice) % 1) * 60)}s`))
                // console.log('credits:', docSnapshot.data().credits)
                setCredits(docSnapshot.data().credits || 0);
              }
          });
              return () => unsubscribe();
          }
    }, [user]);



      useEffect(() => {
        const checkReviewEligibility = async () => {
          if (!selectedConsultant?.id || !user?.id) return;

          try {
            const payRef = doc(db, "priestsPay", selectedConsultant?.id, "users", user?.id);
            const paySnap = await getDoc(payRef);

            if (paySnap.exists() && paySnap.data().totalAmountPaid > MINIMUM_AMOUNT) {
              setCanReview(true);
            } else {
              setCanReview(false);
            }
          } catch (error) {
            console.error("Error checking review eligibility:", error);
            setCanReview(false);
            mixpanel.track('checkReviewEligibilityError', {
              error: error,
              user: user.uid
            })
          }
        };

        checkReviewEligibility();
      }, [selectedConsultant?.id, user?.id]);

      // const updateCreditInFirestore = async () => {
      //     console.log("user: ", user);
      //     if (user?.id) {
      //         const userRef = doc(db, "priest_users", user.id);
      //         try {
      //             const latestCredits = credits - selectedConsultant.ratePerMinute; // Get latest deduction
      //             await updateDoc(userRef, { credits: latestCredits });
      //         } catch (error) {
      //             console.error("Error updating credit:", error);
      //         }
      //     }
      // };



      const sendMessage = async () => {
        // console.log('userData: ', userData)
        // console.log('activeChat: ', activeChat)
        // console.log('consultant: ', consultant)

        if (!input.trim() || !user || !activeChat?.chatRoomId || !selectedConsultant?.id) return;
        

        if (!passphrase || passphrase.trim() === '') {
          // alert("Please set a secret key before sending messages.");
          setShowDecryptModal(true)
          return;
        }

        mixpanel.track('sending mssg', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // rating: selectedRating,
              // review: reviewText
        })

        try {
          // Step 1: Generate a random AES key for this message
          const aesKey = await crypto.subtle.generateKey(
            { name: "AES-GCM", length: 256 },
            true,
            ["encrypt", "decrypt"]
          );

          // Step 2: Encrypt the message with the AES key
          // const { cipherText, iv } = await encryptText(chatInput, aesKey);
          const { cipherText: encryptedMessage, iv: messageIv } = await encryptText(input, aesKey);

          // Step 3: Encrypt the AES key with the consultant’s passphrase
          const globalKey = await getKeyFromPassphrase(GLOBAL_KEYPHRASE);
          // const consultantKey = await getKeyFromPassphrase(consultantPassphrase);
          const exportedKey = await crypto.subtle.exportKey("raw", aesKey);
          const base64Key = btoa(String.fromCharCode(...new Uint8Array(exportedKey)));

          // 4. Encrypt key with sender's passphrase
          const senderKey = await getKeyFromPassphrase(passphrase);
          const { cipherText: encryptedKeyForSender, iv: encryptedKeyForSenderIv } = await encryptText(base64Key, senderKey);

          // 5. Encrypt key with global key
          const { cipherText: encryptedKeyForGlobal, iv: encryptedKeyForGlobalIv } = await encryptText(base64Key, globalKey);
          // console.log('user.displayName', user)
          // 6. Save the message with encrypted key for sender and global
          await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
            // string:input,
            text: encryptedMessage,
            iv: messageIv,
            [`encryptedKeyFor${user.id}`]: encryptedKeyForSender,
            [`encryptedKeyFor${user.id}Iv`]: encryptedKeyForSenderIv,
            encryptedKeyForGlobal,
            encryptedKeyForGlobalIv,
            [`encryptedKeyFor${selectedConsultant.id}`]: null,
            [`encryptedKeyFor${selectedConsultant.id}Iv`]: null,
            [`needsReceiverKeyEncryption${selectedConsultant.id}`]: true,
            [`needsReceiverKeyEncryption${user.id}`]:false,
            sender: user.name || user.displayName || "Unknown User",                
            type: "text", // Add this line so the UI knows it's a text message
            photoURL: auth.currentUser.photoURL,
            createdAt: serverTimestamp(),
            // string: input,
          });


            try {
              // console.log('selectedConsultant: ', selectedConsultant)
              // Send alert using EmailJS
            await emailjs.send(
              'service_kxsob6t', 
              'template_qztflps', 
              {
              // userId: user?.uid,
              username: user?.displayName,
              consultantName:selectedConsultant.name,
              consultantEmail:selectedConsultant.email,
              // to_email: 'info@priests.africa',
              // message: fullReport,
            }, 'iTUAGGcFXyrJu_f0s');

            } catch (error) {
               console.error("Error uploading audio:", error);
               mixpanel.track('sendMessageEmailError', {
                error: error,
                user: user.uid
              })
            }

          setInput("");
        } catch (error) {
          mixpanel.track('sendMessageError', {
            error: error,
            user: user.uid
          })
          console.error("Error sending message:", error);
        }
      };


  const sendWelcomeMessage = async () => {
    if (!selectedConsultant?.id || !activeChat?.chatRoomId) return;

    const message = `Hello! Welcome 🙏🏽. Please briefly introduce yourself and let me know what you need help with. This helps us start your session smoothly. `;

    try {
      await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
        text: message,
        sender: selectedConsultant.username || selectedConsultant.name,
        type: "text",
        createdAt: serverTimestamp(),
        photoURL: selectedConsultant.photoURL || "/default-avatar.png"
      });
    } catch (error) {
      console.error("Error sending welcome message:", error);
      mixpanel.track('sendWelcomeMessageError', {
        error: error,
        user: user.uid
      })
    }
  };

  // Handle sending the sacrifice invoice
      const sendConsultationInvoice = async () => {
        // Send the invoice to the recipient with the sacrifice amount and description
        try {
          await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
            text: `Consultation Invoice`,
            sender: selectedConsultant?.username || selectedConsultant?.name,
            type: "invoice",
            status: "unpaid",
            amount: selectedConsultant.consultationCharge,
            currency: "USD",
            // paymentMethod: paymentMethod,
            createdAt: serverTimestamp(),
          });
      
        } catch (error) {
          console.error("Error sending invoice:", error);
          mixpanel.track('sendConsultationInvoiceError', {
            error: error,
            user: user.uid
          })
        }
      };
  


  async function decryptAllMessages() {
    try {
          let key = globalDecryptionKey;

          if (!key){

              if (!passphrase || passphrase.trim() === '') {
              // alert("Please set a secret key before sending messages.");
              setShowDecryptModal(true)
              return;
            }

            key = await getKeyFromPassphrase(passphrase)
            setGlobalDecryptionKey(key)
          }

          const updatedDecryptedMessages = {};
  
          for (const msg of messages) {
            let decryptedKeyStr = null;
            let aesKey = null;
            // console.log('e enter 1')
            if (msg[`needsReceiverKeyEncryption${user.id}`] && msg.encryptedKeyForGlobal && msg.encryptedKeyForGlobalIv) {
              // Re-encrypt logic
              // console.log('e enter 2')
              try {
                const globalKey = await getKeyFromPassphrase(GLOBAL_KEYPHRASE);
  
                decryptedKeyStr = await decryptText(
                  msg.encryptedKeyForGlobal,
                  msg.encryptedKeyForGlobalIv,
                  globalKey
                );
  
                const { cipherText, iv } = await encryptText(decryptedKeyStr, key);
                // const needsReEncryption = msg[`needsReceiverKeyEncryption${user.id}`];
                // console.log("needsReEncryption: ", needsReEncryption)

                // if (needsReEncryption) {
                  await updateDoc(msg.ref, {
                    [`encryptedKeyFor${user.id}`]: cipherText,
                    [`encryptedKeyFor${user.id}Iv`]: iv,
                    [`needsReceiverKeyEncryption${user.id}`]: false,
                    encryptedKeyForGlobal: deleteField(),
                    encryptedKeyForGlobalIv: deleteField(),
                  });
                // }
  
                const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["encrypt", "decrypt"]);
  
                const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                updatedDecryptedMessages[msg.id] = decryptedText;
                continue;
              } catch (err) {
                console.warn(`Skipping message ${msg.id}: failed to re-encrypt key.`, err);
                mixpanel.track('decryptAllMessages1Error', {
                error: err,
                user: user.uid
              })
                continue;
              }
            }
  
            // Decrypt normally if key available
            const encryptedKey = msg[`encryptedKeyFor${user.id}`];
            const encryptedKeyIv = msg[`encryptedKeyFor${user.id}Iv`];
  
            if (encryptedKey && encryptedKeyIv) {
              try {
                if (!decryptedKeyStr) {
                  decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
                }
                const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
                const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                updatedDecryptedMessages[msg.id] = decryptedText;
              } catch (err) {
                console.warn(`Skipping decryption for message ${msg.id}`, err);
              //   mixpanel.track('decryptAllMessages2Error', {
              //   error: err,
              //   user: user.uid
              // })
              }
            }
          }
  
          setDecryptedMessages(updatedDecryptedMessages);
          // Save base64 version to localStorage for reuse
          // const exported = await crypto.subtle.exportKey("raw", key);
          // const base64Key = btoa(String.fromCharCode(...new Uint8Array(exported)));
          // localStorage.setItem("decryptionKeyFor_" + user.id, base64Key);

        } catch (err) {
          console.error("Error during decryption:", err);
          mixpanel.track('decryptAllMessages3Error', {
            error: err,
            user: user.uid
          })
        }
      }
  
  
      async function decryptSingleMessage(msg, key) {
        try {
          let decryptedKeyStr = null;
          let aesKey = null;
          const key = await getKeyFromPassphrase(passphrase)
  
          const encryptedKey = msg[`encryptedKeyFor${user.id}`];
          const encryptedKeyIv = msg[`encryptedKeyFor${user.id}Iv`];
  
          if (encryptedKey && encryptedKeyIv) {
            decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
            const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
            aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);
            const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
  
            setDecryptedMessages(prev => ({
              ...prev,
              [msg.id]: decryptedText,
            }));
          }
        } catch (err) {
          console.warn(`Failed to decrypt message ${msg.id}`, err);
          mixpanel.track('decryptSingleMessageError', {
            error: err,
            user: user.uid
          })
        }
  }
         

      const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}m ${s}s`;
      };



      const sendQuestionnaireInfo = async () => {
          try {
              // console.log('user:', user)
          await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
              text: `Questionnaire Info:\nName: ${formData.name}\nDOB: ${formData.dob}\nMother's Name: ${formData.motherName}\nFather's Name: ${formData.fatherName}\nBirth Place: ${formData.birthPlace}\nOrigin: ${formData.origin}`,
              sender: user.name || user.displayName,
              type: "text",
              createdAt: serverTimestamp(),
              photoURL: user.photoURL,
          });
          } catch (error) {
          console.error("Error sending questionnaire info:", error);
          mixpanel.track('sendQuestionaireInfoError', {
            error: error,
            user: user.uid
          })
          }
      };
    
      
      
      const startRecording = async () => {
        mixpanel.track('recording...', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // rating: selectedRating,
              // review: reviewText
            })
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          mediaRecorderRef.current = new MediaRecorder(stream);
          audioChunksRef.current = [];
      
          mediaRecorderRef.current.ondataavailable = (event) => {
            if (event.data.size > 0) {
              audioChunksRef.current.push(event.data);
            }
          };
      
          mediaRecorderRef.current.onstop = async () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
            // Create a unique filename (e.g., using a timestamp)
            const filename = `audioMessages/${Date.now()}.wav`;
            const storageRef = ref(storage, filename);
            try {
              // Upload the blob to Firebase Storage
              await uploadBytes(storageRef, audioBlob);
              // Get the download URL for the uploaded file
              const downloadURL = await getDownloadURL(storageRef);
              // Now add the message to Firestore using the permanent download URL
              await addDoc(collection(db, "chatRooms", activeChat.chatRoomId, "messages"), {
                audio: downloadURL,
                sender: user.name || user.displayName,
                type: "audio",
                createdAt: serverTimestamp()
              });
            } catch (error) {
              console.error("Error uploading audio:", error);
              mixpanel.track('startRecordingError1', {
                error: error,
                user: user.uid
              })
            }
            setRecording(false);

            try {
              // console.log('selectedConsultant: ', selectedConsultant)
              // Send alert using EmailJS
            await emailjs.send(
              'service_kxsob6t', 
              'template_qztflps', 
              {
              // userId: user?.uid,
              username: user?.displayName,
              consultantName:selectedConsultant.name,
              consultantEmail:selectedConsultant.email,
              // to_email: 'info@priests.africa',
              // message: fullReport,
            }, 'iTUAGGcFXyrJu_f0s');

            } catch (error) {
               console.error("Error uploading audio:", error);
               mixpanel.track('startRecordingError2', {
                error: error,
                user: user.uid
              })
            }
              
          };
      
          mediaRecorderRef.current.start();
          setRecording(true);
        } catch (error) {
          console.error("Error starting recording:", error);
        }
      };
      
       const stopRecording = () => {
          try {
            if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);
          }
          } catch (error) {
              console.error("Error stopping recording:", error);
              mixpanel.track('stopRecording', {
                error: error,
                user: user.uid
              })
          }
        };


        const handleDeleteChat = async () => {

          // await handleSubmitReview()
          mixpanel.track('end chat totally', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // rating: selectedRating,
              // review: reviewText
            })
      

          if (!activeChat?.chatRoomId) return;
      
        try {
          await updateDoc(doc(db, "chatRooms", activeChat.chatRoomId), {
            status: "ended"
          });
      
          setShowEndChatModal(false);
          setShowChatEndedModal(false)
          selectedConsultant=null;
          activeChat=null;
          navigate("/");
        } catch (error) {
          console.error("Error ending chat:", error);
          mixpanel.track('handleDeleteChatError', {
            error: error,
            user: user.uid
          })
        }
        };


        const handleEndChat = async () => {

          mixpanel.track('exit chat', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // rating: selectedRating,
              // review: reviewText
            })
          // await handleSubmitReview()
            // setShowEndChatModal(false);
            // setSelectedConsultant(null); // Navigate to homepage safely
            // setActiveChat(false)
        
            if (!activeChat?.chatRoomId) return;
        
          // try {
          //   await updateDoc(doc(db, "chatRequests", activeChat.chatRoomId), {
          //     status: "ended"
          //   });
        
            setShowEndChatModal(false);
            setShowChatEndedModal(false)
            selectedConsultant=null;
            activeChat=null;
            navigate("/");
          // } catch (error) {
          //   console.error("Error ending chat:", error);
          // }
          };
        
          const handleChatEndedModal = () => {
            setShowChatEndedModal(false)
            selectedConsultant=null;
            activeChat=null;
            navigate("/");

          }


    const openRechargeModal = () => {
        mixpanel.track('recharge modal open', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // rating: selectedRating,
              // review: reviewText
            })
        setShowRechargeModal(true);
        setShowPaymentForm(false);
        };

    const handleCheckout = async (amount, isGift, recipientEmail, recipientName) => {

      if (amount <= 1.99) {
        alert("Amount must be greater than 14.99");
        return;
      }

      mixpanel.track('inchat handleCheckout', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              method: sacrificePaymentMethod,
              amount: amount
            })
      try {
          // if (amount <= 29.9) {
          //     alert("Amount must be greater than 29.9");
          //     return;
          // }
  

      // TODO: looks at this charges again for correctness
            // Add your 10% platform fee
            const platformFeeRate = 0.10;
            // const stripeFeeRate = 0.015;  // 1.5%
            // const stripeFixedFee = 0.3;  // $0.3
      
            // Add your 10% platform fee
            let totalAmount = amount * (1 + platformFeeRate);
      
            // Calculate Stripe reverse fee
            // const finalAmountToCharge = (targetAmount + stripeFixedFee) / (1 - stripeFeeRate);
      
            // console.log("User ID:", user?.uid);
            // console.log("User wants to send to priest:", amount);
            // console.log("After 10% platform fee, total is:", totalAmount);
            // console.log("Including Stripe fee, user should be charged:", finalAmountToCharge.toFixed(2));
      
            const endpoint = paymentMethod === "paystack"
              ? "https://www.priests.africa/api/paystackpayments"
              : "https://www.priests.africa/api/payments";
      
            if (paymentMethod == "paystack") {
              // convert to naira for paystack
              totalAmount = totalAmount * 2000
            }
      
            // const endpoint = paymentMethod === "paystack"
            // ? "http://localhost:3000/api/paystackpayments"
            // : "https://www.priests.africa/api/payments";

            // console.log('userId: ', user?.id)
            // console.log('amount: ', totalAmount, 'myamount: ', amount,)
      
            const response = await fetch(endpoint, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ amount: totalAmount, myamount: amount, userId: user?.id, isGift: isGift, recipientEmail: isGift ? recipientEmail : null, recipientName: isGift ? recipientName : null, senderName: user?.displayName }),
            });
            const data = await response.json();
            // console.log("API Response:", data);
            // console.log("Response:", response);
      
      
            if (!data.url) {
              console.log("Response from backend:", data);
              throw new Error("No URL returned from backend");
            }
      
            window.location.href = data.url;
          } catch (error) {
            mixpanel.track('handleCheckOutError', {
              error: error?.message,
              user: user?.id
            })
            console.error("Checkout error:", error);
          }
        };
        

  const handleSacrificeCheckout = async (amount) => {
     mixpanel.track('handleSacrificeCheckout', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              method: sacrificePaymentMethod,
              amount: amount
            })
    try {

      if (amount <= 1) {
        alert("Amount must be greater than 1");
        return;
      }

       if (!invoiceId) {
          console.error("No invoice selected for payment.");
          return;
        }


      if (sacrificePaymentMethod === "credits") {
          const userRef = doc(db, "priest_users", user.id);
          const userSnap = await getDoc(userRef);

          if (!userSnap.exists()) {
            alert("User not found.");
            return;
          }

          const currentCredits = userSnap.data().credits || 0;

          if (amount > currentCredits) {
            // alert("Insufficient credits.");
            setInsufficient(true)
            return;
          }

          // Deduct the amount and update Firestore
          await updateDoc(userRef, {
            credits: currentCredits - amount
          });


          
          // ✅ Add amount to consultant's credits
          const consultantRef = doc(db, "priest_users", selectedConsultant.id);
          const consultantSnap = await getDoc(consultantRef);

          if (consultantSnap.exists()) {
            const consultantCredits = consultantSnap.data().credits || 0;
            await updateDoc(consultantRef, {
              credits: consultantCredits + amount,
            });
          } else {
            // If consultant doc doesn't exist (shouldn't happen), create it with credits
            await setDoc(consultantRef, {
              credits: amount,
            });
          }

          // ✅ Update Firestore with the payment made
          const payRef = doc(db, "priestsPay", selectedConsultant.id, "users", user.id);
          const paySnap = await getDoc(payRef);

          if (paySnap.exists()) {
            const prevAmount = paySnap.data().totalAmountPaid || 0;
            await updateDoc(payRef, {
              totalAmountPaid: prevAmount + amount,
              lastPaidAt: serverTimestamp()
            });
          } else {
            await setDoc(payRef, {
              totalAmountPaid: amount,
              lastPaidAt: serverTimestamp()
            });
          }

          // console.log("Firestore updated successfully.");
          try {
                // const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
                // const q = query(messagesRef, where("type", "==", "invoice"));

                // const snapshot = await getDocs(q);

                // // Loop through each invoice message and set status to 'paid'
                // const batch = writeBatch(db); // Use a batch for efficient updates

                // snapshot.forEach(docSnap => {
                //   const docRef = doc(db, "chatRooms", activeChat.chatRoomId, "messages", docSnap.id);
                //   batch.update(docRef, { status: "paid" });
                // });

                // await batch.commit(); // Apply all updates
                // console.log("All invoice statuses updated to 'paid'.");
                
                // Optional: update UI state
                // const updatedInvoices = snapshot.docs.map(doc => ({
                //   id: doc.id,
                //   ...doc.data(),
                //   status: "paid", // override status in local state too
                // }));
                // if (!invoiceId) {
                //   console.error("No invoice selected for payment.");
                //   return;
                // }

                const invoiceRef = doc(db, "chatRooms", activeChat.chatRoomId, "messages", invoiceId);
                await updateDoc(invoiceRef, {
                  status: "paid"
                });
                // console.log("Invoice status updated to 'paid'.");

                // ✅ Update UI (optional but recommended)
                setConsultantInvoices(prevInvoices =>
                  prevInvoices.map(inv =>
                    inv.id === invoiceId ? { ...inv, status: "paid" } : inv
                  )
                );
                setShowInvoicesModal(true);
                setShowSacrificeModal(false)
              } catch (error) {
                console.error("Error updating invoice status:", error);
                mixpanel.track('handleSacrificeCheckoutError', {
                  error: error,
                  user: user.uid
                })
              }


          return; // Exit so it doesn’t try Stripe/Paystack after credits
        }


      
      // TODO: looks at this charges again for correctness
      // Add your 10% platform fee
      const platformFeeRate = 0.10;
      // const stripeFeeRate = 0.015;  // 1.5%
      // const stripeFixedFee = 0.3;  // $0.3

      // Add your 10% platform fee
      let totalAmount = amount * (1 + platformFeeRate);

      // Calculate Stripe reverse fee
      // const finalAmountToCharge = (targetAmount + stripeFixedFee) / (1 - stripeFeeRate);

      // console.log("User ID:", user?.uid);
      // console.log("User wants to send to priest:", amount);
      // console.log("After 10% platform fee, total is:", totalAmount);
      // console.log("Including Stripe fee, user should be charged:", finalAmountToCharge.toFixed(2));


      
      const endpoint = sacrificePaymentMethod === "paystack"
        ? "https://www.priests.africa/api/paystackpayments"
        : "https://www.priests.africa/api/payments";

      // converting from naira to dollars
      // amount = amount/2000
  
      if (sacrificePaymentMethod == "paystack") {
        totalAmount = totalAmount * 2000; // Convert to Naira for Paystack
      }
  
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: totalAmount, userId: user?.id }),
      });
  
      const data = await response.json();
      if (!data.url) {
        throw new Error("No URL returned from backend");
      }
  
      window.location.href = data.url; // Redirect to the payment URL
    } catch (error) {
      console.error("Checkout error:", error);
      mixpanel.track('handleSacrificeCheckoutError', {
        error: error,
        user: user.uid
      })
    }
  };
  
      

  // If selectedConsultant is null or undefined, show a loading state
  if (!selectedConsultant || !user || !activeChat) {
      return <div>Loading...</div>;  // Or any other appropriate loading state
    }


    const fetchNairaToDollarRate = async () => {
       mixpanel.track('dollarrate', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // amount: amount
            })
      try {
        const res = await fetch('https://v6.exchangerate-api.com/v6/303aba2add6b464cb3c48e01/latest/USD');
        const data = await res.json();
        const CBN_nairaRate = data.conversion_rates.NGN;
        const nairaRate = CBN_nairaRate - 20 
        // totalAmount = totalAmount * nairaRate;

        // console.log('nairaRate: ', nairaRate)

        if (nairaRate) {
          // console.log('1/nairaRate: ', 1/nairaRate)
          return 1 / nairaRate; // Convert NGN → USD
        } else {
          console.warn("Exchange rate for NGN not found, using fallback.");
          return 0.0005;
        }
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
        mixpanel.track('fetchNairaDollarRateError', {
          error: error,
          user: user.uid
        })
        return 0.0005; // Fallback rate
      }
    };


      const viewInvoices = async () => {
          if (!activeChat?.chatRoomId || !user?.id) return;
          mixpanel.track('viewinvoices', {
              user: user.id || 'no userid',
              consultant: selectedConsultant.name || selectedConsultant.username,
              // amount: amount
            })
        
          try {
            const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
            const q = query(messagesRef, where("type", "==", "invoice"), orderBy("createdAt", "desc")); // assuming consultant.username is used when sending
        
            const snapshot = await getDocs(q);
            const invoices = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // console.log("invoices: ", invoices)
            setConsultantInvoices(invoices);
            setShowInvoicesModal(true);
          } catch (error) {
            console.error("Error fetching invoices:", error);
            mixpanel.track('viewInvoicesError', {
              error: error,
              user: user.uid
            })
          }
      };


      // const handleReportChat = async () => {
      //     if (!activeChat || !activeChat.chatRoomId) {
      //       alert("No active chat to report.");
      //       return;
      //     }
      //     mixpanel.track('report chat', {
      //         user: user.id || 'no userid',
      //         consultant: selectedConsultant.name || selectedConsultant.username,
      //         // amount: amount
      //       })
        
      //     try {
      //       // setLoading(true);
        
      //       const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
      //       const q = query(messagesRef, orderBy("createdAt", "asc"));
      //       const snapshot = await getDocs(q);
        
      //       const messageList = snapshot.docs.map((doc) => {
      //         const msg = doc.data();
      //         const time = msg.createdAt?.seconds
      //           ? new Date(msg.createdAt.seconds * 1000).toLocaleString()
      //           : "Unknown time";
        
      //         let content = `Sender: ${msg.sender}\nTime: ${time}\nType: ${msg.type}\n`;
        
      //         if (msg.type === 'text') {
      //           content += `Message: ${msg.text}\n`;
      //         } else if (msg.type === 'audio') {
      //           content += `Audio: ${msg.audio}\n`;
      //         } else if (msg.type === 'video') {
      //           content += `Video: ${msg.video}\n`;
      //         } else if (msg.type === 'invoice') {
      //           content += `Invoice Description: ${msg.description}\nAmount: ${msg.amount} ${msg.currency}\nStatus: ${msg.status}\n`;
      //         }
        
      //         return content + '\n---\n';
      //       });
        
      //       const fullReport = messageList.join('');

      //       // Send using EmailJS
      //       await emailjs.send(
      //         'service_kxsob6t', 
      //         'template_p1rfk5g', 
      //         {
      //         userId: user?.id,
      //         userName: user?.displayName,
      //         // to_email: 'info@priests.africa',
      //         message: fullReport,
      //       }, 'iTUAGGcFXyrJu_f0s');
            

      //       setReportSent(true)
        
      //       // alert("Chat report sent succesfully for investigation.");
      //     } catch (error) {
      //       console.error("Error reporting chat:", error);
      //       alert("Failed to send report. Please try again.");
      //     } finally {
      //       // setLoading(false);
      //     }
      //   };
    

    const handleReportChat = async () => {
        if (!activeChat || !activeChat.chatRoomId) {
          alert("No active chat to report.");
          return;
        }

        mixpanel.track('report chat', {
          user: user.id || 'no userid',
          consultant: selectedConsultant.name || selectedConsultant.username,
        });

        try {
          const key = await getKeyFromPassphrase(passphrase.toLowerCase());
          const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
          const q = query(messagesRef, orderBy("createdAt", "asc"));
          const snapshot = await getDocs(q);

          const messageList = [];

          for (const doc of snapshot.docs) {
            const msg = doc.data();
            const time = msg.createdAt?.seconds
              ? new Date(msg.createdAt.seconds * 1000).toLocaleString()
              : "Unknown time";

            let content = `Sender: ${msg.sender}\nTime: ${time}\nType: ${msg.type}\n`;

            if (msg.type === 'text') {
              try {
                const encryptedKey = msg[`encryptedKeyFor${user.id}`];
                const encryptedKeyIv = msg[`encryptedKeyFor${user.id}Iv`];

                if (!encryptedKey || !encryptedKeyIv) continue;

                const decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
                const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);

                const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                content += `Message: ${decryptedText}\n`;

              } catch (err) {
                console.warn(`Could not decrypt message ${doc.id}`, err);
                content += `Message: [Could not decrypt message]\n`;
                mixpanel.track('handleReportChatError', {
                  error: err,
                  user: user.uid
                })
              }
            } else if (msg.type === 'audio') {
              content += `Audio: ${msg.audio}\n`;
            } else if (msg.type === 'video') {
              content += `Video: ${msg.video}\n`;
            } else if (msg.type === 'invoice') {
              content += `Invoice Description: ${msg.description}\nAmount: ${msg.amount} ${msg.currency}\nStatus: ${msg.status}\n`;
            }

            messageList.push(content + '\n---\n');
          }

          const fullReport = messageList.join('');

          // Send the full report to admin using EmailJS
          await emailjs.send(
            'service_kxsob6t',
            'template_p1rfk5g',
            {
              userId: user?.id,
              userName: user?.displayName,
              message: fullReport,
            },
            'iTUAGGcFXyrJu_f0s'
          );

          setReportSent(true);
        } catch (error) {
          console.error("Error reporting chat:", error);
          mixpanel.track('handleReportError', {
            error: error,
            user: user.uid
          })
          alert("Failed to send report. Please try again.");
        }
      };

    const confirmReport = async () => {
      setLoading(true);
      await handleReportChat(); // your original function to send the report
      setLoading(false);
      setShowReportModal(false);
    };




    const handleScanChat = async () => {
      setShowScannerModal(true);
      setLoading(true);
      setError("");
      setScanResult(null);

      mixpanel.track('scanchat', {
        user: user.id || 'no userid',
        consultant: selectedConsultant.name || selectedConsultant.username,
      });

      try {
        const key = await getKeyFromPassphrase(passphrase.toLowerCase());
        const messagesRef = collection(db, "chatRooms", activeChat.chatRoomId, "messages");
        const q = query(messagesRef, orderBy("createdAt", "asc"));
        const snapshot = await getDocs(q);

        const messageList = [];

        for (const doc of snapshot.docs) {
          const msg = doc.data();
          const time = msg.createdAt?.seconds
            ? new Date(msg.createdAt.seconds * 1000).toLocaleString()
            : "Unknown time";

          let content = `Sender: ${msg.sender}\nTime: ${time}\nType: ${msg.type}\n`;

          if (msg.type === 'text') {
            try {
              const encryptedKey = msg[`encryptedKeyFor${user.id}`];
              const encryptedKeyIv = msg[`encryptedKeyFor${user.id}Iv`];

              if (!encryptedKey || !encryptedKeyIv) continue;

              const decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
              const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
              const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);

              const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
              content += `Message: ${decryptedText}\n`;

            } catch (err) {
              console.warn(`Could not decrypt message ${doc.id}`, err);
              content += `Message: [Could not decrypt message]\n`;
              mixpanel.track('handleScanChatError', {
                error: err,
                user: user.uid
              })
            }
          } else if (msg.type === 'audio') {
            content += `Audio: ${msg.audio}\n`;
          } else if (msg.type === 'video') {
            content += `Video: ${msg.video}\n`;
          } else if (msg.type === 'invoice') {
            content += `Invoice Description: ${msg.description}\nAmount: ${msg.amount} ${msg.currency}\nStatus: ${msg.status}\n`;
          }

          messageList.push(content + '\n---\n');
        }

        const chatTranscript = messageList.join('');

        const response = await axios.post('/api/scan-chat', { chatTranscript });

        const analysis = typeof response.data.analysis === 'string'
          ? JSON.parse(response.data.analysis)
          : response.data.analysis;

        setScanResult(analysis);

      } catch (err) {
        console.error(err);
        mixpanel.track('scanChatError', {
          error: err,
          user: user.uid
        })
        setError(String(err) + " Unable to scan the chat. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

  


    //   if (activeChat) {
  return (
    <div className="chat-container">
       <div className="chat-header">
    <Container fluid className="d-flex flex-column vh-100">
      {/* Header */}
      <Row className="p-2 bg-white shadow-sm align-items-center"
      //  style={{
      //     position: 'fixed',
      //     top: 0,
      //     left: 0,
      //     right: 0,
      //     zIndex: 1000,
      //   }}
      >
        {/* <Col xs="auto"> */}
            <Button variant="link" className="text-dark" onClick={() => setShowEndChatModal(true)}>
              <FaTimes size={20} />
            </Button>
        {/* </Col> */}
        
       

       {/* Consultant Info (Image + Name) */}
        <Col className="d-flex align-items-center overflow-hidden">
            <Image
            src={selectedConsultant?.photoURL || "https://via.placeholder.com/40"}
            roundedCircle
            width={30}
            height={30}
            className="me-2 flex-shrink-0"
            />
             {consultantMode !== 'busy' && (
                <div className="d-flex align-items-center">
                  <span
                    style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      marginRight: '8px',
                      backgroundColor: consultantMode === 'online' ? 'green' : 'gray',
                      display: 'inline-block',
                    }}
                  />
                  {/* {consultantMode} */}
                </div>
              )}
            {/* <h5 className="mb-0">
            {selectedConsultant?.username?.trim() ? selectedConsultant.username : selectedConsultant.name}
            </h5> */}
            <div
              className="text-truncate"
              style={{
                maxWidth: "200px",  // adjust as needed
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={selectedConsultant?.username?.trim() ? selectedConsultant.username : selectedConsultant.name} // optional: show full name on hover
            >
              {selectedConsultant?.username?.trim()
                ? selectedConsultant.username
                : selectedConsultant.name}
            </div>
        </Col>

        {/* Credits Button */}
        <Col xs="auto">
            <Button variant="light" onClick={openRechargeModal}>
                {/* Balance:  */}
                <a style={{marginLeft: '5px' }}>
                 {/* {credits === null ? "Loading..." :  credits.toFixed(2)}  */}
                 {credits === null ? (
                      "Loading..."
                    ) : !timeRemaining || timeRemaining === "Invalid" ? (
                      <>{credits.toFixed(2)} 
                        <img 
                          src="/cowrieblack.png" // Update with the correct path
                          alt="Feather Icon" 
                          style={{ width: '20px', height: '20px'}} 
                        />
                      </>
                    ) : (
                      <>
                      <FaClock/>
                      {timeRemaining}</>
                    )}
                
                </a> 
            </Button>
            {/* More Button */}
            <Button className="me-0"
              variant="success"
              onClick={() => setShowMoreOptions(true)}
            >
              <FaEllipsisH />

            </Button>
        </Col>
      </Row>

      {/* Chat Messages */}
      <Row className="flex-grow-1 overflow-auto p-3">
        <Col>
          {messages.map((msg) => (
            <div key={msg.id} className={`d-flex ${msg.sender === user.name || msg.sender === user.displayName ? "justify-content-end" : "justify-content-start"} align-items-center mb-3`}>
              {/* Sender Profile Picture */}
              {msg.sender !== user.name && msg.sender !== user.displayName && (
                <Image
                  src={selectedConsultant?.photoURL || "https://via.placeholder.com/40"}
                  roundedCircle
                  width={40}
                  height={40}
                  className="me-2"
                />
              )}
              {/* style={{marginBottom:25}} */}
              {/* Message Bubble */}
              <div className={`p-3 rounded shadow ${msg.sender === user.name || msg.sender === user.displayName ? "bg-success text-white" : "bg-light text-dark"}`} style={{ maxWidth: "80%", marginBottom:40 }}>
                <strong className="d-block small">{msg.sender === user.name || msg.sender === user.displayName ? msg.sender : selectedConsultant?.username?.trim() ? selectedConsultant.username : selectedConsultant.name}</strong>
              
                {/* Check the message type and display accordingly */}
                {msg.type === "text" ? (
                    <span
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSelectedMessage(msg);
                        setDecryptedText('');
                        // setPassphrase('');
                        // setShowDecryptModal(true);
                        handleRequestDecrypt(msg)
                      }}
                    >
                      {/* {decryptedMessages[msg.id] || msg.text} */}
                        {decryptedMessages[msg.id] ? (
                          <span>{decryptedMessages[msg.id]}</span>
                        ) : (
                          <div>
                            <div>{msg.text}</div>
                          </div>

                        )}
                    </span>
                  ) : msg.type === "audio" ? (
                        <div className="d-flex align-items-center gap-2 mt-2">
                        {audioErrors[msg.id] ? (
                          <div className="text-danger small">
                            Cannot play voice note.
                          </div>
                        ) : (
                          <audio
                            controls
                            src={msg.audio}
                            onError={(e) => {
                              console.error("Audio error for msg: ", msg, e);
                              mixpanel.track('audioError', {
                                error: msg,
                                user: user.id || user.uid || 'user id not found'
                              });
                              setAudioErrors(prev => ({ ...prev, [msg.id]: true }));
                            }}
                            className="flex-grow-1"
                            style={{ minWidth: "150px" }}
                          />
                        )}

                        <a
                          href={msg.audio}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-light rounded-circle d-flex align-items-center justify-content-center shadow"
                          style={{
                            width: "40px",
                            height: "40px",
                            flexShrink: 0,
                            flexGrow: 0,
                            padding: 0,
                            border: "1px solid rgba(255,255,255,0.5)",
                          }}
                          title="Download audio"
                        >
                          <i className="bi bi-download" style={{ fontSize: "18px", color: "#000", filter: "none" }} />
                        </a>
                        </div>
                      )
                      : msg.type === "video" ? (
                    <video controls width="100%" style={{ maxHeight: 200 }}>
                      <source src={msg.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : msg.type === "invoice" ? (
                        <div className="mt-2">
                          <p className="mb-2"><strong>Invoice</strong> from <em>{selectedConsultant?.username?.trim() ? selectedConsultant.username : selectedConsultant.name}</em>:</p>
                          <p className="mb-1">{msg.description}</p>
                          <p className="mb-2 fw-semibold">Amount: {msg.amount} { msg.currency}</p>
                          <p className="mb-2 fw-semibold">Status: {msg.status}</p>
                          <Button
                            onClick={async () => {
                              let amountInDollars = msg.amount;

                              if (msg.currency === 'Naira') {
                                const rate = await fetchNairaToDollarRate();
                                amountInDollars = parseFloat((msg.amount * rate).toFixed(2));
                              }
                                // console.log('rate: ', rate)

                              setInvoiceId(msg.id)
                              setSacrificeAmount(amountInDollars);
                              setSacrificePaymentMethod(msg.paymentMethod || 'credits');
                              setShowSacrificeModal(true);
                            }}
                            variant="outline-success"
                            style={{ padding: '6px 20px', fontSize: '14px' }}
                          >
                            Pay Now
                          </Button>
                        </div>
                      ): null}

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <p style={{ marginTop: '15px', marginBottom: 0, marginLeft: 'auto', fontSize:'12px', }}>
                    {(!decryptedMessages[msg.id] && (
                          msg[`encryptedKeyFor${selectedConsultant?.id}`] || msg.encryptedKeyForGlobal
                        )) && (
                          <FaRegEyeSlash 
                            style={{ fontSize: 18, marginRight: '5px', verticalAlign: 'middle' }} 
                            onClick={() => {
                                  setSelectedMessage(msg);
                                  setDecryptedText('');
                                  // setPassphrase('');
                                  // setShowDecryptModal(true);
                                  handleRequestDecrypt(msg)
                                }}
                          />
                      )}
                    {msg.createdAt &&
                      '@'+ new Date(msg.createdAt.seconds * 1000).toLocaleTimeString(undefined, {
                        weekday: 'short',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}                            
                    </p>
                  </div> 

              </div>

              {/* Receiver Profile Picture */}
              {(msg.sender === user.name || msg.sender === user.displayName) && (
                <Image
                  src={user.photoURL || "https://via.placeholder.com/40"}
                  roundedCircle
                  width={40}
                  height={40}
                  className="ms-2"
                />
              )}
            </div>
          ))}
          {/* Auto-scroll to latest message */}
          <div ref={messagesEndRef} />
        </Col>
      </Row>

      {/* Fixed Input Box at Bottom */}
      <Row className="p-3 bg-white shadow-sm fixed-bottom">
        <Col>
          <Form className="d-flex align-items-center">
            <Form.Control
              type="text"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevents line break in input
                      sendMessage(); // Call your message sending function
                    }
                  }}
              className="me-2"
            />
            <Button variant="success" onClick={sendMessage} className="me-2">
              <FaPaperPlane />
            </Button>
            {recording ? (
              <Button variant="danger" onClick={stopRecording}>
                Stop
              </Button>
            ) : (
              <Button variant="primary" onClick={startRecording}>
                <FaMicrophone />
              </Button>
            )}
          </Form>
        </Col>
      </Row>


      
      {/* show decrypting modal */}
      <Modal show={showDecryptModal} onHide={() => setShowDecryptModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-success">Set Key ?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
            <p className="text-muted small mb-2">
              🔒 This protects your private conversations from hacking.
            </p>
            <p className="text-muted small mb-2">
              🔑 <b>DO NOT</b> enter a key unless you're <b>100% sure you'll always remember it </b> as keys are not stored by Priests.Africa.
            </p>
            <p className="text-muted small mb-4">
             ⚠️ Entering New keys will result in loss of access to old messages.
            </p>
            {/* <Form.Text className="text-muted mt-1 d-block" style={{ fontSize: '0.8rem' }}>
            </Form.Text> */}
          <Form.Group controlId="passphraseInput">
            {/* <Form.Label className="fw-semibold text-secondary small">Use either your easiest-to-remember password or most favorite name?</Form.Label> */}
            <Form.Control
              placeholder="Enter key?"
              // type="text"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              style={{ fontSize: '0.95rem' }}
            />
            
          </Form.Group>
          <div className="d-flex justify-content-center mt-4">
          <Button
            className="px-4 py-2 rounded-pill shadow-sm"
            style={{ fontWeight: 500, fontSize: '1rem' }}
            variant="success"
            onClick={async () => {
              try {
                const key = await getKeyFromPassphrase(passphrase.toLowerCase());

                const updatedDecryptedMessages = {};

                for (const msg of messages) {
                  let decryptedKeyStr = null;
                  let aesKey = null;

                  if (msg[`needsReceiverKeyEncryption${user.id}`] && msg.encryptedKeyForGlobal && msg.encryptedKeyForGlobalIv) {
                    try {
                      const globalKey = await getKeyFromPassphrase(GLOBAL_KEYPHRASE);

                      // Step 1: Decrypt AES key with global key
                      decryptedKeyStr = await decryptText(
                        msg.encryptedKeyForGlobal,
                        msg.encryptedKeyForGlobalIv,
                        globalKey
                      );

                      // Step 2: Re-encrypt AES key with user's passphrase-derived key
                      const { cipherText, iv } = await encryptText(decryptedKeyStr, key);
                      // const needsReEncryption = msg[`needsReceiverKeyEncryption${user.id}`];
                      // console.log('needsReEncryption: ', needsReEncryption)
                      
                      // if (needsReEncryption) {
                        // Step 3: Save to Firestore
                        await updateDoc(msg.ref, {
                          [`encryptedKeyFor${user.id}`]: cipherText,
                          [`encryptedKeyFor${user.id}Iv`]: iv,
                          [`needsReceiverKeyEncryption${user.id}`]: false,
                          encryptedKeyForGlobal: deleteField(),
                          encryptedKeyForGlobalIv: deleteField(),
                        });
                      // }

                      const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                      aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);

                      const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                      updatedDecryptedMessages[msg.id] = decryptedText;
                      continue;
                      
                    } catch (err) {
                      console.warn(`Skipping message ${msg.id}: failed to re-encrypt key.`, err);
                      mixpanel.track('rencryptionButton1Error', {
                        error: err,
                        user: user.uid
                      })
                      continue; // Skip failed ones
                    }
                  }

                  // Try decrypting if AES key encrypted with consultant passphrase exists
                  const encryptedKey = msg[`encryptedKeyFor${user.id}`];
                  const encryptedKeyIv = msg[`encryptedKeyFor${user.id}Iv`];

                  if (encryptedKey && encryptedKeyIv) {
                    try {
                      if (!decryptedKeyStr) {
                        decryptedKeyStr = await decryptText(encryptedKey, encryptedKeyIv, key);
                      }

                      const rawKey = Uint8Array.from(atob(decryptedKeyStr), c => c.charCodeAt(0));
                      const aesKey = await crypto.subtle.importKey("raw", rawKey, "AES-GCM", true, ["decrypt"]);

                      const decryptedText = await decryptText(msg.text, msg.iv, aesKey);
                      updatedDecryptedMessages[msg.id] = decryptedText;
                    } catch (err) {
                      // Don't set error message — just skip silently
                      // console.warn(`Skipping decryption for message ${msg.id}`, err);
                      mixpanel.track('rencryptionButton2Error', {
                        error: err,
                        user: user.uid
                      })
                    }
                  }
                }

                // ✅ Update decrypted messages state (or however you're storing it)
                setDecryptedMessages(updatedDecryptedMessages);
                setGlobalDecryptionKey(key);
                // Save base64 version to localStorage for reuse
                const exported = await crypto.subtle.exportKey("raw", key);
                const base64Key = btoa(String.fromCharCode(...new Uint8Array(exported)));
                localStorage.setItem("decryptionKeyFor_" + user.id, base64Key);
                sessionStorage.setItem("decryptionKeyFor_" + user.id, base64Key);
                // ✅ Refresh the page to re-render with decrypted messages
                // window.location.reload();
                setShowDecryptModal(false); // Close modal
              } catch (err) {
                console.error("Error during decryption:", err);
                mixpanel.track('rencryptionButton3Error', {
                  error: err,
                  user: user.uid
                })
                // Optionally: setDecryptedText("Decryption failed."); but no need in this UX
              }
            }}
          >
            <FaRegEye/> Decrypt
          </Button>
          </div>

          {/* {decryptedText && (
            <div className="mt-3">
              <strong>Decrypted Message:</strong>
              <div className="border p-2 mt-2">{decryptedText}</div>
            </div>
          )} */}
        </Modal.Body>
      </Modal>


      {/* End Chat Confirmation Modal*/}
      <Modal show={showEndChatModal} onHide={() => setShowEndChatModal(false)} centered>
        <Modal.Header closeButton className="border-0" >
          <Modal.Title className="fw-bold text-primary">Leave Chat?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          {(timeRemaining && timeRemaining !== "Invalid") && (
            <p className="fs-6 text-muted">
              With 'Exit Chat' you will still get charged as long as the Priest is still on your case.
            </p>
          )}
        
          <Form>
            {/* <div className="mt-3"> */}
            {(timeRemaining && timeRemaining !== "Invalid") && ( <Form.Check className="fs-6 text-muted mb-4"
                type="checkbox"
                id="end-chat-checkbox"
                label="Activate 'END Chat' button to END chats totally with this priest?"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />

            )}
            {/* </div> */}
            {/* {typeof timeRemaining === "number" && timeRemaining > 0 && (
                <Form.Check
                  className="fs-6 text-muted mb-4"
                  type="checkbox"
                  id="end-chat-checkbox"
                  label="Activate 'END Chat' button to END chats totally with this priest?"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
              )} */}

              {/* Review Section */}
              <div className="mb-3">
                <h6 className="fw-bold">Rate Your Experience</h6>
                <div className="d-flex mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar
                      key={star}
                      size={25}
                      onClick={() => setSelectedRating(star)}
                      style={{
                        marginRight: 6,
                        cursor: "pointer",
                        color: star <= selectedRating ? "#ffc107" : "#e4e5e9"
                      }}
                  />
                ))}
              </div>
            {canReview && (
              <Form.Control
                as="textarea"
                rows={3}
                placeholder={`Write a short review about ${selectedConsultant?.name|| 'the consultant'}? (optional)`}
                value={reviewText}
                onChange={(e) => setReviewText(e.target.value)}
                style={{
                  borderRadius: "12px",
                  border: "1px solid #dee2e6",
                  boxShadow: "none",
                  fontSize: "14px"
                }}
              />
                )}
          <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
            {reviewSubmitted && (
                <small className="text-success fw-semibold">Review submitted!</small>
              )}
          <Button variant="outline-dark" onClick={handleSubmitReview}>
            Submit
          </Button>
        </div>
          </div>
      

          </Form>


        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end">
        {(timeRemaining && timeRemaining !== "Invalid") && ( 
          <Button variant="outline-dark"
              onClick={handleDeleteChat} disabled={!isChecked}>
            END Chat
          </Button>
          )}
          {/* {typeof timeRemaining === "number" && timeRemaining > 0 && (
              <Button variant="outline-dark" onClick={handleDeleteChat} disabled={!isChecked}>
                END Chat
              </Button>
            )} */}

            
            <Button variant="primary"  onClick={handleEndChat}>
              Exit Chat
            </Button>
        </Modal.Footer>
      </Modal>

        {/* end chat request sent by consultant*/}
       <Modal show={showChatEndedModal} onHide={handleChatEndedModal} centered>
            <Modal.Header closeButton className="border-0">
              <Modal.Title>Chat Ended</Modal.Title>
            </Modal.Header>
            <Modal.Body>This chat has been ended.</Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={handleChatEndedModal}>
                Close Chat
              </Button>
            </Modal.Footer>
          </Modal>          

          {/* Recharge? */}
                <Modal
                  show={rechargeNotificationModal}
                  onHide={() => {
                    setRechargeNotificationModal(false);
                  }}
                  centered
                  className="rounded-3 shadow-lg"
                >
                  <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fw-bold text-primary">Recharge?</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="px-4 py-3">
                      <p className="fs-5 text-muted">
                        You have only about {timeRemaining} left ({credits} cowries), would you like to recharge?
                      </p>
                  </Modal.Body>
                    <Modal.Footer className="border-0">
                      <Button
                        variant="outline-secondary"
                        size="lg"
                        onClick={() => {
                          setRechargeNotificationModal(false)
                        }}
                      >
                        Ignore
                      </Button>
                      <Button variant="primary" size="lg" onClick={() =>{
                        openRechargeModal()
                        setRechargeNotificationModal(false)
                        }}>
                        Recharge
                      </Button>
                    </Modal.Footer>
                </Modal>

                {/* Top Payment Modal */}
                <Modal show={showRechargeModal} onHide={() => setShowRechargeModal(false)} centered className="rounded-4" contentClassName="border-0 shadow-lg">
                  <Modal.Header closeButton className="border-0 px-4 pt-4">
                      <Modal.Title className="fw-semibold fs-5 text-primary">Enter Credit Amount</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="px-4 pb-4 pt-2">
                  <div className="d-flex flex-column align-items-center gap-3 w-100">
                  {/* <Form.Text className="text-muted w-100 text-start" style={{ fontSize: 13 }}>
                      1 USD = 1 Cowrie 
                  </Form.Text> */}
                    <div className="w-100" style={{ maxWidth: "320px" }}>
                      <label className="form-label text-muted mb-1" style={{ fontSize: "12px" }}>
                        1 USD = 1 Cowrie
                      </label>
                      <input
                        type="number"
                        className="form-control text-center"
                        style={{
                          maxWidth: "320px",
                          borderRadius: "12px",
                          padding: "12px 16px",
                          fontSize: "15px",
                          border: "1px solid #dee2e6",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                          transition: "all 0.3s ease"
                        }}
                        placeholder="Enter amount (minimum $15.0)"
                        value={customAmount}
                        onChange={(e) => setCustomAmount(e.target.value)}
                        min="20.0"
                      />
                    </div>
          
                          <div className="w-100" style={{ maxWidth: "320px" }}>
                              <Form.Label className="text-muted mb-1" style={{ fontSize: 13 }}>
                                Choose Payment Method
                              </Form.Label>
                              <select
                                className="form-select"
                                style={{
                                  borderRadius: "12px",
                                  padding: "10px 14px",
                                  fontSize: "15px",
                                  border: "1px solid #dee2e6"
                                }}
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                              >
                                {/* <option value="credits">💰 Pay with Credit (Cowries)</option> */}
                                <option value="stripe">💳 Pay with Stripe</option>
                                {/* <option value="paystack"> Pay with Paystack</option> */}
                              </select>
                            </div>

                            <p className="text-muted small mt-2 mb-2">
                              Priests.Africa fee = 10%
                              (all transaction fees included)
                            </p>
          
                            <Button
                              variant="primary"
                              className="fw-semibold mt-2"
                              style={{
                                padding: "10px 24px",
                                borderRadius: "14px",
                                fontSize: "15px",
                                boxShadow: "0 4px 10px rgba(0, 123, 255, 0.2)",
                                transition: "background-color 0.3s ease"
                              }}
                              onClick={() => handleCheckout(Number(customAmount), isGift, recipientEmail, recipientName)}
                              disabled={!customAmount || Number(customAmount) <= 1}
                            >
                              {/* Pay ${customAmount || 0} with {paymentMethod === "stripe" ? "Stripe" : "Paystack"} */}
                              Pay ${customAmount || 0} with {paymentMethod === "stripe" ? "Stripe" : "Credit"}
                            </Button>
                      </div>

                
                  </Modal.Body>
              </Modal>


                {/* Invoice Modal */}
                <Modal show={showSacrificeModal} onHide={() => {setShowSacrificeModal(false); setInsufficient(false)}} centered className="rounded-3 shadow-lg">
                    <Modal.Header closeButton className="border-0">
                        {/* <Modal.Title className="fw-bold text-primary">Enter Credit Amount</Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body className="px-4 py-3">
                    <div className="d-flex flex-column align-items-center gap-3 w-100">
                    {/* <Form.Text className="text-muted w-100 text-start" style={{ fontSize: 12 }}>
                        $1 is equivalent to 1 Cowrie
                    </Form.Text> */}
                    {/* <p className="text-muted small mb-2">
                      Stripe fee = 1.5% + £0.2
                    </p>
                    <p className="text-muted small mb-4">
                      Priests.Africa fee = 10%
                    </p> */}
                    {/* <p className="text-muted small mb-0">
                      1 USD = 1 Cowrie
                    </p> */}
                    {/* <p className="text-muted small mb-2">
                      Priests.Africa fee = 10%
                      (all transaction fees included)
                    </p> */}
                    <input 
                        type="number" 
                        className="form-control text-center"
                        style={{
                            maxWidth: "280px",
                            borderRadius: "10px",
                            padding: "10px",
                            fontSize: "14px",
                            border: "1px solid #ccc",
                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)"
                        }}
                        placeholder="Enter amount (greater than 1.4)"
                        value={sacrificeAmount}
                        onChange={(e) => setSacrificeAmount(e.target.value)}
                        min="1.4"
                        disabled
                    />
                           

                        <Button 
                            variant="primary" 
                            className="px-4 py-2 fw-bold rounded-3"
                            onClick={() => handleSacrificeCheckout(Number(sacrificeAmount))}
                            disabled={!sacrificeAmount || Number(sacrificeAmount) <= 1}
                        >
                              Pay {sacrificeAmount || 0}  <img 
                          src="/cowrieharsh.png" // Update with the correct path
                          alt="Feather Icon" 
                          style={{ width: '20px', height: '20px'}} 
                        />
                              {/* Pay ${sacrificeAmount || 0} with {sacrificePaymentMethod === "stripe" ? "Stripe" : "Paystack" : "credits"} */}

                        </Button>

                        {insufficient && (
                        <div
                          className="text-center py-3 px-3"
                          style={{
                            backgroundColor: "#ffffff",
                            borderBottom: "1px solid #e0e0e0",
                            fontFamily: "Inter, sans-serif",
                          }}
                        >
                          <div
                            style={{
                              maxWidth: "600px",
                              margin: "0 auto",
                              padding: "20px",
                              borderRadius: "10px",
                              backgroundColor: "#f9f9f9",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.03)",
                            }}
                          >
                            <h5 style={{ color: "#333", marginBottom: "10px" }}>
                              Sorry, your credit is insufficient
                            </h5>
                          </div>
                        </div>
                        )}
                    </div>
                    
                </Modal.Body>
            </Modal>


            <Modal
                show={showInvoicesModal}
                onHide={() => setShowInvoicesModal(false)}
                centered
                scrollable
                size="lg"
                contentClassName="border-0 rounded-4 shadow-lg"
                dialogClassName="p-2"
              >
                <Modal.Header closeButton className="border-0 pb-0">
                  <Modal.Title className="w-100 text-center fs-4 fw-semibold text-dark">Invoices</Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-3 px-4">
                  {consultantInvoices.length === 0 ? (
                    <div className="text-center py-5 text-muted">No invoices found.</div>
                  ) : (
                    consultantInvoices.map((invoice) => (
                      <div
                        key={invoice.id}
                        className="rounded-3 border bg-light p-4 mb-4 shadow-sm"
                      >
                        <div className="d-flex flex-column gap-2">
                          <div><strong>Type:</strong> {invoice.text}</div>
                          <div><strong>Sent:</strong> {invoice.createdAt?.seconds
                            ? new Date(invoice.createdAt.seconds * 1000).toLocaleString()
                            : "Unknown date"}</div>
                          <div><strong>Description:</strong> {invoice.description || 'No description'}</div>
                          <div><strong>Amount:</strong> {invoice.amount} {invoice.currency}</div>
                          <div>
                            <strong>Status:</strong>{" "}
                            <span className={invoice.status === 'paid' ? "text-success fw-semibold" : "text-danger fw-semibold"}>
                              {invoice.status}
                            </span>
                          </div>

                          {invoice.status !== 'paid' && (
                            <div className="mt-3 text-end">
                              <Button
                                variant="success"
                                className="px-4 py-2"
                                onClick={async () => {
                                  // console.log('invoice: ', invoice)
                                  let amountInDollars = invoice.amount;
                                  if (invoice.currency === 'Naira') {
                                    const rate = await fetchNairaToDollarRate();
                                    amountInDollars = parseFloat((invoice.amount * rate).toFixed(2));
                                  }
                                  // console.log('msg.id: ', invoice)
                                  setInvoiceId(invoice.id)
                                  setSacrificeAmount(amountInDollars);
                                  setSacrificePaymentMethod(invoice.paymentMethod || 'credits');
                                  setShowSacrificeModal(true);
                                }}
                              >
                                Pay Now
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </Modal.Body>

                <Modal.Footer className="border-0">
                  <Button
                    variant="outline-secondary"
                    className="w-100 py-2"
                    onClick={() => setShowInvoicesModal(false)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>


          <Modal show={showReportModal} onHide={() => {
            setScanResult(false)
            setReportSent(false)
            setShowReportModal(false)
            }} centered>
            <Modal.Header closeButton>
              <Modal.Title className="d-flex align-items-center gap-2 text-danger"> Red-Flag Scanner</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              {!scanResult && !loading && (<p className="text-muted fs-6">
                Do you want to scan this chat for Red Flags?
              </p>)}
             
              {loading && (
                <div className="text-center">
                  <Spinner animation="border" role="status" />
                  <p className="mt-2 text-muted">Scanning chat...</p>
                </div>
              )}

              {error && <Alert variant="danger">{error}</Alert>}

              {scanResult && (
                  <Alert variant="light" className="border-start border-4 border-danger text-start shadow-sm">
                    <div className="d-flex align-items-start mb-2">
                      <FaFlag className="text-danger me-2 mt-1" />
                      <div>
                        <strong className="text-danger">{scanResult.redflag_number} red flags found</strong>
                        <p className="mb-0 mt-1 text-dark">{scanResult.summary}</p>
                      </div>
                    </div>
                    <hr />
                    <p className="text-muted mb-1 small">Would you like to report this chat for further investigation?</p>
                  </Alert>
                )}
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between align-items-center">
            {reportSent && <small className="text-success fw-semibold">✓ Report Submitted!</small>} 

              <div className="ms-auto d-flex gap-2">
                  

                  {!scanResult && (
                    <Button variant="danger" onClick={handleScanChat} disabled={loading}>
                      {loading ? "Scanning..." : "Yes"}
                    </Button>
                  )}

                  {scanResult && (
                    <Button variant="danger" onClick={handleReportChat}>
                      Yes, Report it
                    </Button>
                  )}

                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      setScanResult(false);
                      setReportSent(false);
                      setShowReportModal(false);
                    }}
                  >
                    Close
                  </Button>
                </div>
            </Modal.Footer>
          </Modal>
          

      </Container>

      </div>

      <Offcanvas
      show={showMoreOptions}
      onHide={() => setShowMoreOptions(false)}
      placement="top"
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        height: '180px',
        margin: '0 auto',
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        zIndex: 1055,
        transition: 'transform 0.3s ease-in-out',
      }}
    >
  <Offcanvas.Header
    closeButton
    className="border-0 pt-3 pb-2 px-4"
    style={{ fontWeight: '500', fontSize: '1rem', color: '#333' }}
  >
    {/* <Offcanvas.Title className="w-100 text-center">Options</Offcanvas.Title> */}
      </Offcanvas.Header>

      <Offcanvas.Body className="d-flex flex-column align-items-center gap-3 px-4">
        <Button
          variant="outline-success"
          className="w-100"
          onClick={() => setShowReportModal(true)}
        >
          <FaRegFlag className="me-2" /> Red Flag Scanner
        </Button>

        <Button
          variant="outline-success"
          className="w-100"
          onClick={viewInvoices}
        >
          Check Invoice(s)
        </Button>
      </Offcanvas.Body>
    </Offcanvas>

    </div>
  );
        
       
//   );
};

export default ActiveUserChat;
